import { render } from "./AppSkeletonCardTable.vue?vue&type=template&id=6e2710a9&scoped=true"
import script from "./AppSkeletonCardTable.vue?vue&type=script&lang=js"
export * from "./AppSkeletonCardTable.vue?vue&type=script&lang=js"

import "./AppSkeletonCardTable.vue?vue&type=style&index=0&id=6e2710a9&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2710a9"]])

export default __exports__